/** API origin. Empty string = same-origin (production build served by Express). */
function resolveApiBaseUrl() {
  const configured = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') ?? '';
  if (typeof window === 'undefined' || !configured) {
    return configured;
  }

  try {
    const api = new URL(configured);
    const pageHost = window.location.hostname;
    const pageIsLocal = pageHost === 'localhost' || pageHost.endsWith('.localhost');
    const apiIsLocal = api.hostname === 'localhost' || api.hostname === '127.0.0.1';
    if (pageIsLocal && apiIsLocal && pageHost !== api.hostname) {
      api.hostname = pageHost;
      return api.origin;
    }
  } catch {
    return configured;
  }

  return configured;
}

export const API_BASE_URL = resolveApiBaseUrl();
